import { Component, Injector } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { MedicinalproductsService } from '../../service/medicinalproducts-service/medicinalproducts.service';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { environment } from '../../../../environments/environment';
import { AttachmentDocument } from '../../service/medicinalproducts-service/attachmentDocument';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, from, mergeMap, throwError } from 'rxjs';

@Component({
  selector: 'app-document-view-type',
  templateUrl: './document-view-type.component.html',
  styleUrl: './document-view-type.component.scss'
})
export class DocumentViewTypeComponent  extends FieldType {

  constructor (private injector: Injector) {
    super();
  }

  openFileInNewWindow() {
    this.injector.get(MedicinalproductsService)
      .getAttachmentDocument(this.formControl.value)
      .subscribe({
        next: (data: HttpResponse<Blob>) => {
          // Extract filename from Content-Disposition header (supports filename and filename*)
          const fileName: string =
            data.headers.get('Content-Disposition')
              ?.match(/filename\*?=(?:UTF-8''|")?([^;"']+)/i)?.[1] ?? 'undefined';

          // Derive file extension from filename
          const extension = fileName.split('.').pop() || '';

          // Map extension to a MIME subtype (used to build application/<type>)
          let documenType = '';
          switch (extension.toLowerCase()) {
            case 'pdf':  documenType = 'pdf'; break;
            case 'doc':  documenType = 'msword'; break;
            case 'docx': documenType = 'vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
            case 'xls':  documenType = 'vnd.ms-excel'; break;
            case 'xlsx': documenType = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
            default:     documenType = 'octet-stream'; // safe fallback
          }

          // Create an Object URL for the received Blob with the appropriate type
          const url = URL.createObjectURL(new Blob([data.body!], { type: `application/${documenType}` }));

          // Create a temporary anchor to trigger the download
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);

          // Remove loading state before triggering download
          this.injector.get(Art57Section).removeIsLoading();

          // Trigger the download
          a.click();

          // Cleanup: remove the anchor and revoke the Object URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          // Optional: show a success toast
          this.injector.get(Art57Section).showTooltipMessage({
            severity: 'success',
            detail: `Attachment Document ${fileName} Downloaded`,
            life: environment.successElapsedTime
          });
        },
    });
  }

}
